import React from 'react';
import { connect } from "react-redux";
import Loader from '../../Global/loader';
import './main.scss';
import Layout from './Layout/Layout'
import { requireAuthentication } from './../../Global/requireAuthentication'

export class AdminMain extends React.Component{
    state={
        loading: true
    }

    componentDidMount(){
        this.setState({
            loading: false
        })
    }

    render(){       
        const {loading} = this.state        
        return loading ?
                <Loader/>                                   
            : 
                <Layout roles = {this.props.credentials.roles}/>
        }  
}

const mapStateToProps = state => {
    return {
        credentials: state.user
    };
  };
  
  const mapDispatchToProps = dispatch => {
    return {
      mapState: (type, data) => dispatch({ type: type, data: data}),
      API: (type, data) => dispatch({ type: type, data: data})
    };
  };
  
  
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(requireAuthentication(AdminMain));
